module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/hidden-fa8dbc20bd69c2ef9bdffb284115f00d.svg";